import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import FeaturedInfo from "../../components/FeaturedInfo/FeaturedInfo"
import SimpleLineChart from "../../components/SimpleLineChart/SimpleLineChart"
import WidgetSmall from "../../components/WidgetSmall/WidgetSmall"
import WidgetLarge from "../../components/WidgetLarge/WidgetLarge"
// Data
import { userRequest } from "../../requestMethods"
import { getUsers } from "../../redux/apiCalls"
// Styles
import { Container, Main, Widgets, Wrapper } from "./Home.styles"

const Home = () => {
    const dispatch = useDispatch()
    const [userStats, setUserStats] = useState([])

    useEffect(() => {
        const getStats = async () => {
            try {
                const res = await userRequest.get("/users/stats")
                res.data.map((item) => (
                    setUserStats((prev) => [
                        ...prev,
                        { name: item._id, "Active User": item.total }
                    ])
                ))
            } catch (err) {
                setUserStats([])
                console.log(err)
            }
        }
        getStats()
        getUsers(dispatch)
    }, [dispatch])

    return (
        <>
            <Topbar />
            <Container>
                <Wrapper>
                    <Sidebar />
                </Wrapper>
                <Main>
                    <FeaturedInfo />
                    <SimpleLineChart title="User Analytics" data={userStats} dataKey="Active User" grid={true} />
                    <Widgets>
                        <WidgetSmall />
                        <WidgetLarge />
                    </Widgets>
                </Main>
            </Container>
        </>
    )
}

export default Home
